import _regeneratorRuntime from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */
// inspired by https://github.com/maxogden/filereader-stream
import { env, util } from '@tensorflow/tfjs-core';
import { ByteChunkIterator } from './byte_chunk_iterator';
/**
 * Provide a stream of chunks from a File, Blob, or Uint8Array.
 * @param file The source File, Blob or Uint8Array.
 * @param options Optional settings controlling file reading.
 * @returns a lazy Iterator of Uint8Arrays containing sequential chunks of the
 *   input File, Blob or Uint8Array.
 */

export var FileChunkIterator = /*#__PURE__*/function (_ByteChunkIterator) {
  _inherits(FileChunkIterator, _ByteChunkIterator);

  function FileChunkIterator(file) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, FileChunkIterator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FileChunkIterator).call(this));
    _this.file = file;
    _this.options = options;
    util.assert(file instanceof Uint8Array || (env().get('IS_BROWSER') ? file instanceof File || file instanceof Blob : false), function () {
      return 'FileChunkIterator only supports File, Blob and Uint8Array ' + 'right now.';
    });
    _this.offset = options.offset || 0; // default 1MB chunk has tolerable perf on large files

    _this.chunkSize = options.chunkSize || 1024 * 1024;
    return _this;
  }

  _createClass(FileChunkIterator, [{
    key: "summary",
    value: function summary() {
      return "FileChunks ".concat(this.file);
    }
  }, {
    key: "next",
    value: function () {
      var _next = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var chunk;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.offset >= (this.file instanceof Uint8Array ? this.file.byteLength : this.file.size))) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", {
                  value: null,
                  done: true
                });

              case 2:
                chunk = new Promise(function (resolve, reject) {
                  var end = _this2.offset + _this2.chunkSize;

                  if (_this2.file instanceof Uint8Array) {
                    // Note if end > this.uint8Array.byteLength, we just get a small last
                    // chunk.
                    resolve(new Uint8Array(_this2.file.slice(_this2.offset, end)));
                  } else {
                    // This branch assumes that this.file type is File or Blob, which
                    // means it is in the browser environment.
                    // TODO(soergel): is this a performance issue?
                    var fileReader = new FileReader();

                    fileReader.onload = function (event) {
                      var data = fileReader.result; // Not sure we can trust the return type of
                      // FileReader.readAsArrayBuffer See e.g.
                      // https://github.com/node-file-api/FileReader/issues/2

                      if (data instanceof ArrayBuffer) {
                        data = new Uint8Array(data);
                      }

                      if (!(data instanceof Uint8Array)) {
                        return reject(new TypeError('FileReader returned unknown type.'));
                      }

                      resolve(data);
                    };

                    fileReader.onabort = function (event) {
                      return reject(new Error('Aborted'));
                    };

                    fileReader.onerror = function (event) {
                      return reject(new Error(event.type));
                    }; // TODO(soergel): better handle onabort, onerror
                    // Note if end > this.file.size, we just get a small last chunk.


                    var slice = _this2.file.slice(_this2.offset, end); // We can't use readAsText here (even if we know the file is text)
                    // because the slice boundary may fall within a multi-byte character.


                    fileReader.readAsArrayBuffer(slice);
                  }

                  _this2.offset = end;
                });
                _context.next = 5;
                return chunk;

              case 5:
                _context.t0 = _context.sent;
                return _context.abrupt("return", {
                  value: _context.t0,
                  done: false
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function next() {
        return _next.apply(this, arguments);
      }

      return next;
    }()
  }]);

  return FileChunkIterator;
}(ByteChunkIterator);